// extracted by mini-css-extract-plugin
export default {"UserDropdown":"UserDropdown_UserDropdown__MEllQ","userDropdown":"UserDropdown_userDropdown__MXhUF","username":"UserDropdown_username__8j-pR"};